module.exports = __webpack_public_path__ + "img/a-master-of-djinn.8a649bef.png";